/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createServerRootRoute } from '@tanstack/react-start/server'

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SigninIndexRouteImport } from './routes/signin.index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as WorkspaceNewTaskRouteImport } from './routes/workspace/new-task'
import { Route as SigninSsoCallbackRouteImport } from './routes/signin.sso-callback'
import { Route as SigninExpiredRouteImport } from './routes/signin.expired'
import { Route as OnboardingProfileRouteImport } from './routes/onboarding/profile'
import { Route as OnboardingActivationRouteImport } from './routes/onboarding/activation'
import { Route as AdminWorkspacesRouteImport } from './routes/admin/workspaces'
import { Route as AdminWaitlistRouteImport } from './routes/admin/waitlist'
import { Route as AdminServiceRequestsRouteImport } from './routes/admin/service-requests'
import { Route as AdminRealtimeJobsRouteImport } from './routes/admin/realtime-jobs'
import { Route as AdminOutboxRouteImport } from './routes/admin/outbox'
import { Route as AdminMonitorRouteImport } from './routes/admin/monitor'
import { Route as AdminInvitationCodesRouteImport } from './routes/admin/invitation-codes'
import { Route as AdminInboxRouteImport } from './routes/admin/inbox'
import { Route as AdminCampaignRouteImport } from './routes/admin/campaign'
import { Route as AdminAdminsRouteImport } from './routes/admin/admins'
import { Route as WorkspaceWorkspaceSlugRouteRouteImport } from './routes/workspace/$workspaceSlug/route'
import { Route as WorkspaceWorkspaceSlugIndexRouteImport } from './routes/workspace/$workspaceSlug/index'
import { Route as OnboardingWaitlistIndexRouteImport } from './routes/onboarding/waitlist.index'
import { Route as WorkspaceWorkspaceSlugServicesRouteImport } from './routes/workspace/$workspaceSlug/services'
import { Route as WorkspaceWorkspaceSlugNewTaskRouteImport } from './routes/workspace/$workspaceSlug/new-task'
import { Route as WorkspaceWorkspaceSlugInboxRouteImport } from './routes/workspace/$workspaceSlug/inbox'
import { Route as WorkspaceWorkspaceSlugHelpRouteImport } from './routes/workspace/$workspaceSlug/help'
import { Route as WorkspaceWorkspaceSlugContactsRouteImport } from './routes/workspace/$workspaceSlug/contacts'
import { Route as WorkspaceWorkspaceSlugCompaniesRouteImport } from './routes/workspace/$workspaceSlug/companies'
import { Route as ShareTasksShareTokenRouteImport } from './routes/share/tasks/$shareToken'
import { Route as OnboardingWaitlistPendingRouteImport } from './routes/onboarding/waitlist.pending'
import { Route as DemoStartServerFuncsRouteImport } from './routes/demo.start.server-funcs'
import { Route as WorkspaceWorkspaceSlugSettingsRouteRouteImport } from './routes/workspace/$workspaceSlug/settings/route'
import { Route as WorkspaceWorkspaceSlugKnowledgeRouteRouteImport } from './routes/workspace/$workspaceSlug/knowledge/route'
import { Route as WorkspaceWorkspaceSlugSettingsIndexRouteImport } from './routes/workspace/$workspaceSlug/settings/index'
import { Route as WorkspaceWorkspaceSlugProductsIndexRouteImport } from './routes/workspace/$workspaceSlug/products/index'
import { Route as WorkspaceWorkspaceSlugKnowledgeIndexRouteImport } from './routes/workspace/$workspaceSlug/knowledge/index'
import { Route as WorkspaceWorkspaceSlugDealsIndexRouteImport } from './routes/workspace/$workspaceSlug/deals/index'
import { Route as WorkspaceWorkspaceSlugCampaignsIndexRouteImport } from './routes/workspace/$workspaceSlug/campaigns/index'
import { Route as WorkspaceWorkspaceSlugTasksSessionIdRouteImport } from './routes/workspace/$workspaceSlug/tasks/$sessionId'
import { Route as WorkspaceWorkspaceSlugKnowledgeWebsitesRouteImport } from './routes/workspace/$workspaceSlug/knowledge/websites'
import { Route as WorkspaceWorkspaceSlugKnowledgeSourcesRouteImport } from './routes/workspace/$workspaceSlug/knowledge/sources'
import { Route as WorkspaceWorkspaceSlugKnowledgeSnippetsRouteImport } from './routes/workspace/$workspaceSlug/knowledge/snippets'
import { Route as WorkspaceWorkspaceSlugKnowledgeProductsRouteImport } from './routes/workspace/$workspaceSlug/knowledge/products'
import { Route as WorkspaceWorkspaceSlugKnowledgeDocumentsRouteImport } from './routes/workspace/$workspaceSlug/knowledge/documents'
import { Route as WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRouteImport } from './routes/workspace/$workspaceSlug/knowledge/company-profiles'
import { Route as WorkspaceWorkspaceSlugDealsDealIdRouteImport } from './routes/workspace/$workspaceSlug/deals/$dealId'
import { Route as WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRouteImport } from './routes/workspace/$workspaceSlug/campaigns/$campaignId.index'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/referrals'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceMembersRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/members'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/integrations'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/general'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/blacklist'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/billing'
import { Route as WorkspaceWorkspaceSlugSettingsAccountProfileRouteImport } from './routes/workspace/$workspaceSlug/settings/account/profile'
import { Route as WorkspaceWorkspaceSlugSettingsAccountNotificationRouteImport } from './routes/workspace/$workspaceSlug/settings/account/notification'
import { Route as WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRouteImport } from './routes/workspace/$workspaceSlug/campaigns/setup/company-profile'
import { Route as WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRouteImport } from './routes/workspace/$workspaceSlug/campaigns/$campaignId.launch-success'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/billing/index'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/billing/success'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/billing/invoices'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/billing/cancel'
import { Route as WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRouteImport } from './routes/workspace/$workspaceSlug/settings/workspace/billing/billing-info'
import { ServerRoute as ApiHealthServerRouteImport } from './routes/api.health'
import { ServerRoute as ApiDemoNamesServerRouteImport } from './routes/api.demo-names'

const rootServerRouteImport = createServerRootRoute()

const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninIndexRoute = SigninIndexRouteImport.update({
  id: '/signin/',
  path: '/signin/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const WorkspaceNewTaskRoute = WorkspaceNewTaskRouteImport.update({
  id: '/workspace/new-task',
  path: '/workspace/new-task',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninSsoCallbackRoute = SigninSsoCallbackRouteImport.update({
  id: '/signin/sso-callback',
  path: '/signin/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninExpiredRoute = SigninExpiredRouteImport.update({
  id: '/signin/expired',
  path: '/signin/expired',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingProfileRoute = OnboardingProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingActivationRoute = OnboardingActivationRouteImport.update({
  id: '/activation',
  path: '/activation',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const AdminWorkspacesRoute = AdminWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminWaitlistRoute = AdminWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminServiceRequestsRoute = AdminServiceRequestsRouteImport.update({
  id: '/service-requests',
  path: '/service-requests',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRealtimeJobsRoute = AdminRealtimeJobsRouteImport.update({
  id: '/realtime-jobs',
  path: '/realtime-jobs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOutboxRoute = AdminOutboxRouteImport.update({
  id: '/outbox',
  path: '/outbox',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMonitorRoute = AdminMonitorRouteImport.update({
  id: '/monitor',
  path: '/monitor',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminInvitationCodesRoute = AdminInvitationCodesRouteImport.update({
  id: '/invitation-codes',
  path: '/invitation-codes',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminInboxRoute = AdminInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCampaignRoute = AdminCampaignRouteImport.update({
  id: '/campaign',
  path: '/campaign',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAdminsRoute = AdminAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AdminRouteRoute,
} as any)
const WorkspaceWorkspaceSlugRouteRoute =
  WorkspaceWorkspaceSlugRouteRouteImport.update({
    id: '/workspace/$workspaceSlug',
    path: '/workspace/$workspaceSlug',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceWorkspaceSlugIndexRoute =
  WorkspaceWorkspaceSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const OnboardingWaitlistIndexRoute = OnboardingWaitlistIndexRouteImport.update({
  id: '/waitlist/',
  path: '/waitlist/',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const WorkspaceWorkspaceSlugServicesRoute =
  WorkspaceWorkspaceSlugServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugNewTaskRoute =
  WorkspaceWorkspaceSlugNewTaskRouteImport.update({
    id: '/new-task',
    path: '/new-task',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugInboxRoute =
  WorkspaceWorkspaceSlugInboxRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugHelpRoute =
  WorkspaceWorkspaceSlugHelpRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugContactsRoute =
  WorkspaceWorkspaceSlugContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugCompaniesRoute =
  WorkspaceWorkspaceSlugCompaniesRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const ShareTasksShareTokenRoute = ShareTasksShareTokenRouteImport.update({
  id: '/share/tasks/$shareToken',
  path: '/share/tasks/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingWaitlistPendingRoute =
  OnboardingWaitlistPendingRouteImport.update({
    id: '/waitlist/pending',
    path: '/waitlist/pending',
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const DemoStartServerFuncsRoute = DemoStartServerFuncsRouteImport.update({
  id: '/demo/start/server-funcs',
  path: '/demo/start/server-funcs',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceWorkspaceSlugSettingsRouteRoute =
  WorkspaceWorkspaceSlugSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugKnowledgeRouteRoute =
  WorkspaceWorkspaceSlugKnowledgeRouteRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsIndexRoute =
  WorkspaceWorkspaceSlugSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugProductsIndexRoute =
  WorkspaceWorkspaceSlugProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugKnowledgeIndexRoute =
  WorkspaceWorkspaceSlugKnowledgeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceWorkspaceSlugKnowledgeRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugDealsIndexRoute =
  WorkspaceWorkspaceSlugDealsIndexRouteImport.update({
    id: '/deals/',
    path: '/deals/',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugCampaignsIndexRoute =
  WorkspaceWorkspaceSlugCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugTasksSessionIdRoute =
  WorkspaceWorkspaceSlugTasksSessionIdRouteImport.update({
    id: '/tasks/$sessionId',
    path: '/tasks/$sessionId',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugKnowledgeWebsitesRoute =
  WorkspaceWorkspaceSlugKnowledgeWebsitesRouteImport.update({
    id: '/websites',
    path: '/websites',
    getParentRoute: () => WorkspaceWorkspaceSlugKnowledgeRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugKnowledgeSourcesRoute =
  WorkspaceWorkspaceSlugKnowledgeSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => WorkspaceWorkspaceSlugKnowledgeRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugKnowledgeSnippetsRoute =
  WorkspaceWorkspaceSlugKnowledgeSnippetsRouteImport.update({
    id: '/snippets',
    path: '/snippets',
    getParentRoute: () => WorkspaceWorkspaceSlugKnowledgeRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugKnowledgeProductsRoute =
  WorkspaceWorkspaceSlugKnowledgeProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => WorkspaceWorkspaceSlugKnowledgeRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugKnowledgeDocumentsRoute =
  WorkspaceWorkspaceSlugKnowledgeDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => WorkspaceWorkspaceSlugKnowledgeRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRoute =
  WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRouteImport.update({
    id: '/company-profiles',
    path: '/company-profiles',
    getParentRoute: () => WorkspaceWorkspaceSlugKnowledgeRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugDealsDealIdRoute =
  WorkspaceWorkspaceSlugDealsDealIdRouteImport.update({
    id: '/deals/$dealId',
    path: '/deals/$dealId',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRoute =
  WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRouteImport.update({
    id: '/campaigns/$campaignId/',
    path: '/campaigns/$campaignId/',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRouteImport.update({
    id: '/workspace/referrals',
    path: '/workspace/referrals',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceMembersRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceMembersRouteImport.update({
    id: '/workspace/members',
    path: '/workspace/members',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRouteImport.update({
    id: '/workspace/integrations',
    path: '/workspace/integrations',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRouteImport.update({
    id: '/workspace/general',
    path: '/workspace/general',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRouteImport.update({
    id: '/workspace/blacklist',
    path: '/workspace/blacklist',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteImport.update({
    id: '/workspace/billing',
    path: '/workspace/billing',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsAccountProfileRoute =
  WorkspaceWorkspaceSlugSettingsAccountProfileRouteImport.update({
    id: '/account/profile',
    path: '/account/profile',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsAccountNotificationRoute =
  WorkspaceWorkspaceSlugSettingsAccountNotificationRouteImport.update({
    id: '/account/notification',
    path: '/account/notification',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRoute =
  WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRouteImport.update({
    id: '/campaigns/setup/company-profile',
    path: '/campaigns/setup/company-profile',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRoute =
  WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRouteImport.update({
    id: '/campaigns/$campaignId/launch-success',
    path: '/campaigns/$campaignId/launch-success',
    getParentRoute: () => WorkspaceWorkspaceSlugRouteRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRouteImport.update({
    id: '/cancel',
    path: '/cancel',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute,
  } as any)
const WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRoute =
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRouteImport.update({
    id: '/billing-info',
    path: '/billing-info',
    getParentRoute: () => WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute,
  } as any)
const ApiHealthServerRoute = ApiHealthServerRouteImport.update({
  id: '/api/health',
  path: '/api/health',
  getParentRoute: () => rootServerRouteImport,
} as any)
const ApiDemoNamesServerRoute = ApiDemoNamesServerRouteImport.update({
  id: '/api/demo-names',
  path: '/api/demo-names',
  getParentRoute: () => rootServerRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/workspace/$workspaceSlug': typeof WorkspaceWorkspaceSlugRouteRouteWithChildren
  '/admin/admins': typeof AdminAdminsRoute
  '/admin/campaign': typeof AdminCampaignRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/invitation-codes': typeof AdminInvitationCodesRoute
  '/admin/monitor': typeof AdminMonitorRoute
  '/admin/outbox': typeof AdminOutboxRoute
  '/admin/realtime-jobs': typeof AdminRealtimeJobsRoute
  '/admin/service-requests': typeof AdminServiceRequestsRoute
  '/admin/waitlist': typeof AdminWaitlistRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/onboarding/activation': typeof OnboardingActivationRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/signin/expired': typeof SigninExpiredRoute
  '/signin/sso-callback': typeof SigninSsoCallbackRoute
  '/workspace/new-task': typeof WorkspaceNewTaskRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/signin': typeof SigninIndexRoute
  '/workspace/$workspaceSlug/knowledge': typeof WorkspaceWorkspaceSlugKnowledgeRouteRouteWithChildren
  '/workspace/$workspaceSlug/settings': typeof WorkspaceWorkspaceSlugSettingsRouteRouteWithChildren
  '/demo/start/server-funcs': typeof DemoStartServerFuncsRoute
  '/onboarding/waitlist/pending': typeof OnboardingWaitlistPendingRoute
  '/share/tasks/$shareToken': typeof ShareTasksShareTokenRoute
  '/workspace/$workspaceSlug/companies': typeof WorkspaceWorkspaceSlugCompaniesRoute
  '/workspace/$workspaceSlug/contacts': typeof WorkspaceWorkspaceSlugContactsRoute
  '/workspace/$workspaceSlug/help': typeof WorkspaceWorkspaceSlugHelpRoute
  '/workspace/$workspaceSlug/inbox': typeof WorkspaceWorkspaceSlugInboxRoute
  '/workspace/$workspaceSlug/new-task': typeof WorkspaceWorkspaceSlugNewTaskRoute
  '/workspace/$workspaceSlug/services': typeof WorkspaceWorkspaceSlugServicesRoute
  '/onboarding/waitlist': typeof OnboardingWaitlistIndexRoute
  '/workspace/$workspaceSlug/': typeof WorkspaceWorkspaceSlugIndexRoute
  '/workspace/$workspaceSlug/deals/$dealId': typeof WorkspaceWorkspaceSlugDealsDealIdRoute
  '/workspace/$workspaceSlug/knowledge/company-profiles': typeof WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRoute
  '/workspace/$workspaceSlug/knowledge/documents': typeof WorkspaceWorkspaceSlugKnowledgeDocumentsRoute
  '/workspace/$workspaceSlug/knowledge/products': typeof WorkspaceWorkspaceSlugKnowledgeProductsRoute
  '/workspace/$workspaceSlug/knowledge/snippets': typeof WorkspaceWorkspaceSlugKnowledgeSnippetsRoute
  '/workspace/$workspaceSlug/knowledge/sources': typeof WorkspaceWorkspaceSlugKnowledgeSourcesRoute
  '/workspace/$workspaceSlug/knowledge/websites': typeof WorkspaceWorkspaceSlugKnowledgeWebsitesRoute
  '/workspace/$workspaceSlug/tasks/$sessionId': typeof WorkspaceWorkspaceSlugTasksSessionIdRoute
  '/workspace/$workspaceSlug/campaigns': typeof WorkspaceWorkspaceSlugCampaignsIndexRoute
  '/workspace/$workspaceSlug/deals': typeof WorkspaceWorkspaceSlugDealsIndexRoute
  '/workspace/$workspaceSlug/knowledge/': typeof WorkspaceWorkspaceSlugKnowledgeIndexRoute
  '/workspace/$workspaceSlug/products': typeof WorkspaceWorkspaceSlugProductsIndexRoute
  '/workspace/$workspaceSlug/settings/': typeof WorkspaceWorkspaceSlugSettingsIndexRoute
  '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success': typeof WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRoute
  '/workspace/$workspaceSlug/campaigns/setup/company-profile': typeof WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRoute
  '/workspace/$workspaceSlug/settings/account/notification': typeof WorkspaceWorkspaceSlugSettingsAccountNotificationRoute
  '/workspace/$workspaceSlug/settings/account/profile': typeof WorkspaceWorkspaceSlugSettingsAccountProfileRoute
  '/workspace/$workspaceSlug/settings/workspace/billing': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteWithChildren
  '/workspace/$workspaceSlug/settings/workspace/blacklist': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRoute
  '/workspace/$workspaceSlug/settings/workspace/general': typeof WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRoute
  '/workspace/$workspaceSlug/settings/workspace/integrations': typeof WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRoute
  '/workspace/$workspaceSlug/settings/workspace/members': typeof WorkspaceWorkspaceSlugSettingsWorkspaceMembersRoute
  '/workspace/$workspaceSlug/settings/workspace/referrals': typeof WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRoute
  '/workspace/$workspaceSlug/campaigns/$campaignId': typeof WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/billing-info': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/cancel': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/invoices': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/success': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/admin/admins': typeof AdminAdminsRoute
  '/admin/campaign': typeof AdminCampaignRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/invitation-codes': typeof AdminInvitationCodesRoute
  '/admin/monitor': typeof AdminMonitorRoute
  '/admin/outbox': typeof AdminOutboxRoute
  '/admin/realtime-jobs': typeof AdminRealtimeJobsRoute
  '/admin/service-requests': typeof AdminServiceRequestsRoute
  '/admin/waitlist': typeof AdminWaitlistRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/onboarding/activation': typeof OnboardingActivationRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/signin/expired': typeof SigninExpiredRoute
  '/signin/sso-callback': typeof SigninSsoCallbackRoute
  '/workspace/new-task': typeof WorkspaceNewTaskRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/signin': typeof SigninIndexRoute
  '/demo/start/server-funcs': typeof DemoStartServerFuncsRoute
  '/onboarding/waitlist/pending': typeof OnboardingWaitlistPendingRoute
  '/share/tasks/$shareToken': typeof ShareTasksShareTokenRoute
  '/workspace/$workspaceSlug/companies': typeof WorkspaceWorkspaceSlugCompaniesRoute
  '/workspace/$workspaceSlug/contacts': typeof WorkspaceWorkspaceSlugContactsRoute
  '/workspace/$workspaceSlug/help': typeof WorkspaceWorkspaceSlugHelpRoute
  '/workspace/$workspaceSlug/inbox': typeof WorkspaceWorkspaceSlugInboxRoute
  '/workspace/$workspaceSlug/new-task': typeof WorkspaceWorkspaceSlugNewTaskRoute
  '/workspace/$workspaceSlug/services': typeof WorkspaceWorkspaceSlugServicesRoute
  '/onboarding/waitlist': typeof OnboardingWaitlistIndexRoute
  '/workspace/$workspaceSlug': typeof WorkspaceWorkspaceSlugIndexRoute
  '/workspace/$workspaceSlug/deals/$dealId': typeof WorkspaceWorkspaceSlugDealsDealIdRoute
  '/workspace/$workspaceSlug/knowledge/company-profiles': typeof WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRoute
  '/workspace/$workspaceSlug/knowledge/documents': typeof WorkspaceWorkspaceSlugKnowledgeDocumentsRoute
  '/workspace/$workspaceSlug/knowledge/products': typeof WorkspaceWorkspaceSlugKnowledgeProductsRoute
  '/workspace/$workspaceSlug/knowledge/snippets': typeof WorkspaceWorkspaceSlugKnowledgeSnippetsRoute
  '/workspace/$workspaceSlug/knowledge/sources': typeof WorkspaceWorkspaceSlugKnowledgeSourcesRoute
  '/workspace/$workspaceSlug/knowledge/websites': typeof WorkspaceWorkspaceSlugKnowledgeWebsitesRoute
  '/workspace/$workspaceSlug/tasks/$sessionId': typeof WorkspaceWorkspaceSlugTasksSessionIdRoute
  '/workspace/$workspaceSlug/campaigns': typeof WorkspaceWorkspaceSlugCampaignsIndexRoute
  '/workspace/$workspaceSlug/deals': typeof WorkspaceWorkspaceSlugDealsIndexRoute
  '/workspace/$workspaceSlug/knowledge': typeof WorkspaceWorkspaceSlugKnowledgeIndexRoute
  '/workspace/$workspaceSlug/products': typeof WorkspaceWorkspaceSlugProductsIndexRoute
  '/workspace/$workspaceSlug/settings': typeof WorkspaceWorkspaceSlugSettingsIndexRoute
  '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success': typeof WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRoute
  '/workspace/$workspaceSlug/campaigns/setup/company-profile': typeof WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRoute
  '/workspace/$workspaceSlug/settings/account/notification': typeof WorkspaceWorkspaceSlugSettingsAccountNotificationRoute
  '/workspace/$workspaceSlug/settings/account/profile': typeof WorkspaceWorkspaceSlugSettingsAccountProfileRoute
  '/workspace/$workspaceSlug/settings/workspace/blacklist': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRoute
  '/workspace/$workspaceSlug/settings/workspace/general': typeof WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRoute
  '/workspace/$workspaceSlug/settings/workspace/integrations': typeof WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRoute
  '/workspace/$workspaceSlug/settings/workspace/members': typeof WorkspaceWorkspaceSlugSettingsWorkspaceMembersRoute
  '/workspace/$workspaceSlug/settings/workspace/referrals': typeof WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRoute
  '/workspace/$workspaceSlug/campaigns/$campaignId': typeof WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/billing-info': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/cancel': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/invoices': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/success': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRoute
  '/workspace/$workspaceSlug/settings/workspace/billing': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/workspace/$workspaceSlug': typeof WorkspaceWorkspaceSlugRouteRouteWithChildren
  '/admin/admins': typeof AdminAdminsRoute
  '/admin/campaign': typeof AdminCampaignRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/invitation-codes': typeof AdminInvitationCodesRoute
  '/admin/monitor': typeof AdminMonitorRoute
  '/admin/outbox': typeof AdminOutboxRoute
  '/admin/realtime-jobs': typeof AdminRealtimeJobsRoute
  '/admin/service-requests': typeof AdminServiceRequestsRoute
  '/admin/waitlist': typeof AdminWaitlistRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/onboarding/activation': typeof OnboardingActivationRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/signin/expired': typeof SigninExpiredRoute
  '/signin/sso-callback': typeof SigninSsoCallbackRoute
  '/workspace/new-task': typeof WorkspaceNewTaskRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/signin/': typeof SigninIndexRoute
  '/workspace/$workspaceSlug/knowledge': typeof WorkspaceWorkspaceSlugKnowledgeRouteRouteWithChildren
  '/workspace/$workspaceSlug/settings': typeof WorkspaceWorkspaceSlugSettingsRouteRouteWithChildren
  '/demo/start/server-funcs': typeof DemoStartServerFuncsRoute
  '/onboarding/waitlist/pending': typeof OnboardingWaitlistPendingRoute
  '/share/tasks/$shareToken': typeof ShareTasksShareTokenRoute
  '/workspace/$workspaceSlug/companies': typeof WorkspaceWorkspaceSlugCompaniesRoute
  '/workspace/$workspaceSlug/contacts': typeof WorkspaceWorkspaceSlugContactsRoute
  '/workspace/$workspaceSlug/help': typeof WorkspaceWorkspaceSlugHelpRoute
  '/workspace/$workspaceSlug/inbox': typeof WorkspaceWorkspaceSlugInboxRoute
  '/workspace/$workspaceSlug/new-task': typeof WorkspaceWorkspaceSlugNewTaskRoute
  '/workspace/$workspaceSlug/services': typeof WorkspaceWorkspaceSlugServicesRoute
  '/onboarding/waitlist/': typeof OnboardingWaitlistIndexRoute
  '/workspace/$workspaceSlug/': typeof WorkspaceWorkspaceSlugIndexRoute
  '/workspace/$workspaceSlug/deals/$dealId': typeof WorkspaceWorkspaceSlugDealsDealIdRoute
  '/workspace/$workspaceSlug/knowledge/company-profiles': typeof WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRoute
  '/workspace/$workspaceSlug/knowledge/documents': typeof WorkspaceWorkspaceSlugKnowledgeDocumentsRoute
  '/workspace/$workspaceSlug/knowledge/products': typeof WorkspaceWorkspaceSlugKnowledgeProductsRoute
  '/workspace/$workspaceSlug/knowledge/snippets': typeof WorkspaceWorkspaceSlugKnowledgeSnippetsRoute
  '/workspace/$workspaceSlug/knowledge/sources': typeof WorkspaceWorkspaceSlugKnowledgeSourcesRoute
  '/workspace/$workspaceSlug/knowledge/websites': typeof WorkspaceWorkspaceSlugKnowledgeWebsitesRoute
  '/workspace/$workspaceSlug/tasks/$sessionId': typeof WorkspaceWorkspaceSlugTasksSessionIdRoute
  '/workspace/$workspaceSlug/campaigns/': typeof WorkspaceWorkspaceSlugCampaignsIndexRoute
  '/workspace/$workspaceSlug/deals/': typeof WorkspaceWorkspaceSlugDealsIndexRoute
  '/workspace/$workspaceSlug/knowledge/': typeof WorkspaceWorkspaceSlugKnowledgeIndexRoute
  '/workspace/$workspaceSlug/products/': typeof WorkspaceWorkspaceSlugProductsIndexRoute
  '/workspace/$workspaceSlug/settings/': typeof WorkspaceWorkspaceSlugSettingsIndexRoute
  '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success': typeof WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRoute
  '/workspace/$workspaceSlug/campaigns/setup/company-profile': typeof WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRoute
  '/workspace/$workspaceSlug/settings/account/notification': typeof WorkspaceWorkspaceSlugSettingsAccountNotificationRoute
  '/workspace/$workspaceSlug/settings/account/profile': typeof WorkspaceWorkspaceSlugSettingsAccountProfileRoute
  '/workspace/$workspaceSlug/settings/workspace/billing': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteWithChildren
  '/workspace/$workspaceSlug/settings/workspace/blacklist': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRoute
  '/workspace/$workspaceSlug/settings/workspace/general': typeof WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRoute
  '/workspace/$workspaceSlug/settings/workspace/integrations': typeof WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRoute
  '/workspace/$workspaceSlug/settings/workspace/members': typeof WorkspaceWorkspaceSlugSettingsWorkspaceMembersRoute
  '/workspace/$workspaceSlug/settings/workspace/referrals': typeof WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRoute
  '/workspace/$workspaceSlug/campaigns/$campaignId/': typeof WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/billing-info': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/cancel': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/invoices': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/success': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRoute
  '/workspace/$workspaceSlug/settings/workspace/billing/': typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/onboarding'
    | '/workspace/$workspaceSlug'
    | '/admin/admins'
    | '/admin/campaign'
    | '/admin/inbox'
    | '/admin/invitation-codes'
    | '/admin/monitor'
    | '/admin/outbox'
    | '/admin/realtime-jobs'
    | '/admin/service-requests'
    | '/admin/waitlist'
    | '/admin/workspaces'
    | '/onboarding/activation'
    | '/onboarding/profile'
    | '/signin/expired'
    | '/signin/sso-callback'
    | '/workspace/new-task'
    | '/onboarding/'
    | '/signin'
    | '/workspace/$workspaceSlug/knowledge'
    | '/workspace/$workspaceSlug/settings'
    | '/demo/start/server-funcs'
    | '/onboarding/waitlist/pending'
    | '/share/tasks/$shareToken'
    | '/workspace/$workspaceSlug/companies'
    | '/workspace/$workspaceSlug/contacts'
    | '/workspace/$workspaceSlug/help'
    | '/workspace/$workspaceSlug/inbox'
    | '/workspace/$workspaceSlug/new-task'
    | '/workspace/$workspaceSlug/services'
    | '/onboarding/waitlist'
    | '/workspace/$workspaceSlug/'
    | '/workspace/$workspaceSlug/deals/$dealId'
    | '/workspace/$workspaceSlug/knowledge/company-profiles'
    | '/workspace/$workspaceSlug/knowledge/documents'
    | '/workspace/$workspaceSlug/knowledge/products'
    | '/workspace/$workspaceSlug/knowledge/snippets'
    | '/workspace/$workspaceSlug/knowledge/sources'
    | '/workspace/$workspaceSlug/knowledge/websites'
    | '/workspace/$workspaceSlug/tasks/$sessionId'
    | '/workspace/$workspaceSlug/campaigns'
    | '/workspace/$workspaceSlug/deals'
    | '/workspace/$workspaceSlug/knowledge/'
    | '/workspace/$workspaceSlug/products'
    | '/workspace/$workspaceSlug/settings/'
    | '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success'
    | '/workspace/$workspaceSlug/campaigns/setup/company-profile'
    | '/workspace/$workspaceSlug/settings/account/notification'
    | '/workspace/$workspaceSlug/settings/account/profile'
    | '/workspace/$workspaceSlug/settings/workspace/billing'
    | '/workspace/$workspaceSlug/settings/workspace/blacklist'
    | '/workspace/$workspaceSlug/settings/workspace/general'
    | '/workspace/$workspaceSlug/settings/workspace/integrations'
    | '/workspace/$workspaceSlug/settings/workspace/members'
    | '/workspace/$workspaceSlug/settings/workspace/referrals'
    | '/workspace/$workspaceSlug/campaigns/$campaignId'
    | '/workspace/$workspaceSlug/settings/workspace/billing/billing-info'
    | '/workspace/$workspaceSlug/settings/workspace/billing/cancel'
    | '/workspace/$workspaceSlug/settings/workspace/billing/invoices'
    | '/workspace/$workspaceSlug/settings/workspace/billing/success'
    | '/workspace/$workspaceSlug/settings/workspace/billing/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/admin/admins'
    | '/admin/campaign'
    | '/admin/inbox'
    | '/admin/invitation-codes'
    | '/admin/monitor'
    | '/admin/outbox'
    | '/admin/realtime-jobs'
    | '/admin/service-requests'
    | '/admin/waitlist'
    | '/admin/workspaces'
    | '/onboarding/activation'
    | '/onboarding/profile'
    | '/signin/expired'
    | '/signin/sso-callback'
    | '/workspace/new-task'
    | '/onboarding'
    | '/signin'
    | '/demo/start/server-funcs'
    | '/onboarding/waitlist/pending'
    | '/share/tasks/$shareToken'
    | '/workspace/$workspaceSlug/companies'
    | '/workspace/$workspaceSlug/contacts'
    | '/workspace/$workspaceSlug/help'
    | '/workspace/$workspaceSlug/inbox'
    | '/workspace/$workspaceSlug/new-task'
    | '/workspace/$workspaceSlug/services'
    | '/onboarding/waitlist'
    | '/workspace/$workspaceSlug'
    | '/workspace/$workspaceSlug/deals/$dealId'
    | '/workspace/$workspaceSlug/knowledge/company-profiles'
    | '/workspace/$workspaceSlug/knowledge/documents'
    | '/workspace/$workspaceSlug/knowledge/products'
    | '/workspace/$workspaceSlug/knowledge/snippets'
    | '/workspace/$workspaceSlug/knowledge/sources'
    | '/workspace/$workspaceSlug/knowledge/websites'
    | '/workspace/$workspaceSlug/tasks/$sessionId'
    | '/workspace/$workspaceSlug/campaigns'
    | '/workspace/$workspaceSlug/deals'
    | '/workspace/$workspaceSlug/knowledge'
    | '/workspace/$workspaceSlug/products'
    | '/workspace/$workspaceSlug/settings'
    | '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success'
    | '/workspace/$workspaceSlug/campaigns/setup/company-profile'
    | '/workspace/$workspaceSlug/settings/account/notification'
    | '/workspace/$workspaceSlug/settings/account/profile'
    | '/workspace/$workspaceSlug/settings/workspace/blacklist'
    | '/workspace/$workspaceSlug/settings/workspace/general'
    | '/workspace/$workspaceSlug/settings/workspace/integrations'
    | '/workspace/$workspaceSlug/settings/workspace/members'
    | '/workspace/$workspaceSlug/settings/workspace/referrals'
    | '/workspace/$workspaceSlug/campaigns/$campaignId'
    | '/workspace/$workspaceSlug/settings/workspace/billing/billing-info'
    | '/workspace/$workspaceSlug/settings/workspace/billing/cancel'
    | '/workspace/$workspaceSlug/settings/workspace/billing/invoices'
    | '/workspace/$workspaceSlug/settings/workspace/billing/success'
    | '/workspace/$workspaceSlug/settings/workspace/billing'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/onboarding'
    | '/workspace/$workspaceSlug'
    | '/admin/admins'
    | '/admin/campaign'
    | '/admin/inbox'
    | '/admin/invitation-codes'
    | '/admin/monitor'
    | '/admin/outbox'
    | '/admin/realtime-jobs'
    | '/admin/service-requests'
    | '/admin/waitlist'
    | '/admin/workspaces'
    | '/onboarding/activation'
    | '/onboarding/profile'
    | '/signin/expired'
    | '/signin/sso-callback'
    | '/workspace/new-task'
    | '/onboarding/'
    | '/signin/'
    | '/workspace/$workspaceSlug/knowledge'
    | '/workspace/$workspaceSlug/settings'
    | '/demo/start/server-funcs'
    | '/onboarding/waitlist/pending'
    | '/share/tasks/$shareToken'
    | '/workspace/$workspaceSlug/companies'
    | '/workspace/$workspaceSlug/contacts'
    | '/workspace/$workspaceSlug/help'
    | '/workspace/$workspaceSlug/inbox'
    | '/workspace/$workspaceSlug/new-task'
    | '/workspace/$workspaceSlug/services'
    | '/onboarding/waitlist/'
    | '/workspace/$workspaceSlug/'
    | '/workspace/$workspaceSlug/deals/$dealId'
    | '/workspace/$workspaceSlug/knowledge/company-profiles'
    | '/workspace/$workspaceSlug/knowledge/documents'
    | '/workspace/$workspaceSlug/knowledge/products'
    | '/workspace/$workspaceSlug/knowledge/snippets'
    | '/workspace/$workspaceSlug/knowledge/sources'
    | '/workspace/$workspaceSlug/knowledge/websites'
    | '/workspace/$workspaceSlug/tasks/$sessionId'
    | '/workspace/$workspaceSlug/campaigns/'
    | '/workspace/$workspaceSlug/deals/'
    | '/workspace/$workspaceSlug/knowledge/'
    | '/workspace/$workspaceSlug/products/'
    | '/workspace/$workspaceSlug/settings/'
    | '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success'
    | '/workspace/$workspaceSlug/campaigns/setup/company-profile'
    | '/workspace/$workspaceSlug/settings/account/notification'
    | '/workspace/$workspaceSlug/settings/account/profile'
    | '/workspace/$workspaceSlug/settings/workspace/billing'
    | '/workspace/$workspaceSlug/settings/workspace/blacklist'
    | '/workspace/$workspaceSlug/settings/workspace/general'
    | '/workspace/$workspaceSlug/settings/workspace/integrations'
    | '/workspace/$workspaceSlug/settings/workspace/members'
    | '/workspace/$workspaceSlug/settings/workspace/referrals'
    | '/workspace/$workspaceSlug/campaigns/$campaignId/'
    | '/workspace/$workspaceSlug/settings/workspace/billing/billing-info'
    | '/workspace/$workspaceSlug/settings/workspace/billing/cancel'
    | '/workspace/$workspaceSlug/settings/workspace/billing/invoices'
    | '/workspace/$workspaceSlug/settings/workspace/billing/success'
    | '/workspace/$workspaceSlug/settings/workspace/billing/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  WorkspaceWorkspaceSlugRouteRoute: typeof WorkspaceWorkspaceSlugRouteRouteWithChildren
  SigninExpiredRoute: typeof SigninExpiredRoute
  SigninSsoCallbackRoute: typeof SigninSsoCallbackRoute
  WorkspaceNewTaskRoute: typeof WorkspaceNewTaskRoute
  SigninIndexRoute: typeof SigninIndexRoute
  DemoStartServerFuncsRoute: typeof DemoStartServerFuncsRoute
  ShareTasksShareTokenRoute: typeof ShareTasksShareTokenRoute
}
export interface FileServerRoutesByFullPath {
  '/api/demo-names': typeof ApiDemoNamesServerRoute
  '/api/health': typeof ApiHealthServerRoute
}
export interface FileServerRoutesByTo {
  '/api/demo-names': typeof ApiDemoNamesServerRoute
  '/api/health': typeof ApiHealthServerRoute
}
export interface FileServerRoutesById {
  __root__: typeof rootServerRouteImport
  '/api/demo-names': typeof ApiDemoNamesServerRoute
  '/api/health': typeof ApiHealthServerRoute
}
export interface FileServerRouteTypes {
  fileServerRoutesByFullPath: FileServerRoutesByFullPath
  fullPaths: '/api/demo-names' | '/api/health'
  fileServerRoutesByTo: FileServerRoutesByTo
  to: '/api/demo-names' | '/api/health'
  id: '__root__' | '/api/demo-names' | '/api/health'
  fileServerRoutesById: FileServerRoutesById
}
export interface RootServerRouteChildren {
  ApiDemoNamesServerRoute: typeof ApiDemoNamesServerRoute
  ApiHealthServerRoute: typeof ApiHealthServerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin/': {
      id: '/signin/'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/workspace/new-task': {
      id: '/workspace/new-task'
      path: '/workspace/new-task'
      fullPath: '/workspace/new-task'
      preLoaderRoute: typeof WorkspaceNewTaskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin/sso-callback': {
      id: '/signin/sso-callback'
      path: '/signin/sso-callback'
      fullPath: '/signin/sso-callback'
      preLoaderRoute: typeof SigninSsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin/expired': {
      id: '/signin/expired'
      path: '/signin/expired'
      fullPath: '/signin/expired'
      preLoaderRoute: typeof SigninExpiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/profile': {
      id: '/onboarding/profile'
      path: '/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof OnboardingProfileRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/activation': {
      id: '/onboarding/activation'
      path: '/activation'
      fullPath: '/onboarding/activation'
      preLoaderRoute: typeof OnboardingActivationRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/admin/workspaces': {
      id: '/admin/workspaces'
      path: '/workspaces'
      fullPath: '/admin/workspaces'
      preLoaderRoute: typeof AdminWorkspacesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/waitlist': {
      id: '/admin/waitlist'
      path: '/waitlist'
      fullPath: '/admin/waitlist'
      preLoaderRoute: typeof AdminWaitlistRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/service-requests': {
      id: '/admin/service-requests'
      path: '/service-requests'
      fullPath: '/admin/service-requests'
      preLoaderRoute: typeof AdminServiceRequestsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/realtime-jobs': {
      id: '/admin/realtime-jobs'
      path: '/realtime-jobs'
      fullPath: '/admin/realtime-jobs'
      preLoaderRoute: typeof AdminRealtimeJobsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/outbox': {
      id: '/admin/outbox'
      path: '/outbox'
      fullPath: '/admin/outbox'
      preLoaderRoute: typeof AdminOutboxRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/monitor': {
      id: '/admin/monitor'
      path: '/monitor'
      fullPath: '/admin/monitor'
      preLoaderRoute: typeof AdminMonitorRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/invitation-codes': {
      id: '/admin/invitation-codes'
      path: '/invitation-codes'
      fullPath: '/admin/invitation-codes'
      preLoaderRoute: typeof AdminInvitationCodesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inbox': {
      id: '/admin/inbox'
      path: '/inbox'
      fullPath: '/admin/inbox'
      preLoaderRoute: typeof AdminInboxRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaign': {
      id: '/admin/campaign'
      path: '/campaign'
      fullPath: '/admin/campaign'
      preLoaderRoute: typeof AdminCampaignRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/admins': {
      id: '/admin/admins'
      path: '/admins'
      fullPath: '/admin/admins'
      preLoaderRoute: typeof AdminAdminsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/workspace/$workspaceSlug': {
      id: '/workspace/$workspaceSlug'
      path: '/workspace/$workspaceSlug'
      fullPath: '/workspace/$workspaceSlug'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceSlug/': {
      id: '/workspace/$workspaceSlug/'
      path: '/'
      fullPath: '/workspace/$workspaceSlug/'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/onboarding/waitlist/': {
      id: '/onboarding/waitlist/'
      path: '/waitlist'
      fullPath: '/onboarding/waitlist'
      preLoaderRoute: typeof OnboardingWaitlistIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/workspace/$workspaceSlug/services': {
      id: '/workspace/$workspaceSlug/services'
      path: '/services'
      fullPath: '/workspace/$workspaceSlug/services'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugServicesRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/new-task': {
      id: '/workspace/$workspaceSlug/new-task'
      path: '/new-task'
      fullPath: '/workspace/$workspaceSlug/new-task'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugNewTaskRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/inbox': {
      id: '/workspace/$workspaceSlug/inbox'
      path: '/inbox'
      fullPath: '/workspace/$workspaceSlug/inbox'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugInboxRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/help': {
      id: '/workspace/$workspaceSlug/help'
      path: '/help'
      fullPath: '/workspace/$workspaceSlug/help'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugHelpRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/contacts': {
      id: '/workspace/$workspaceSlug/contacts'
      path: '/contacts'
      fullPath: '/workspace/$workspaceSlug/contacts'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugContactsRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/companies': {
      id: '/workspace/$workspaceSlug/companies'
      path: '/companies'
      fullPath: '/workspace/$workspaceSlug/companies'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugCompaniesRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/share/tasks/$shareToken': {
      id: '/share/tasks/$shareToken'
      path: '/share/tasks/$shareToken'
      fullPath: '/share/tasks/$shareToken'
      preLoaderRoute: typeof ShareTasksShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/waitlist/pending': {
      id: '/onboarding/waitlist/pending'
      path: '/waitlist/pending'
      fullPath: '/onboarding/waitlist/pending'
      preLoaderRoute: typeof OnboardingWaitlistPendingRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/demo/start/server-funcs': {
      id: '/demo/start/server-funcs'
      path: '/demo/start/server-funcs'
      fullPath: '/demo/start/server-funcs'
      preLoaderRoute: typeof DemoStartServerFuncsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceSlug/settings': {
      id: '/workspace/$workspaceSlug/settings'
      path: '/settings'
      fullPath: '/workspace/$workspaceSlug/settings'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/knowledge': {
      id: '/workspace/$workspaceSlug/knowledge'
      path: '/knowledge'
      fullPath: '/workspace/$workspaceSlug/knowledge'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/settings/': {
      id: '/workspace/$workspaceSlug/settings/'
      path: '/'
      fullPath: '/workspace/$workspaceSlug/settings/'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/products/': {
      id: '/workspace/$workspaceSlug/products/'
      path: '/products'
      fullPath: '/workspace/$workspaceSlug/products'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugProductsIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/knowledge/': {
      id: '/workspace/$workspaceSlug/knowledge/'
      path: '/'
      fullPath: '/workspace/$workspaceSlug/knowledge/'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugKnowledgeIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRoute
    }
    '/workspace/$workspaceSlug/deals/': {
      id: '/workspace/$workspaceSlug/deals/'
      path: '/deals'
      fullPath: '/workspace/$workspaceSlug/deals'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugDealsIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/campaigns/': {
      id: '/workspace/$workspaceSlug/campaigns/'
      path: '/campaigns'
      fullPath: '/workspace/$workspaceSlug/campaigns'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugCampaignsIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/tasks/$sessionId': {
      id: '/workspace/$workspaceSlug/tasks/$sessionId'
      path: '/tasks/$sessionId'
      fullPath: '/workspace/$workspaceSlug/tasks/$sessionId'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugTasksSessionIdRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/knowledge/websites': {
      id: '/workspace/$workspaceSlug/knowledge/websites'
      path: '/websites'
      fullPath: '/workspace/$workspaceSlug/knowledge/websites'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugKnowledgeWebsitesRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRoute
    }
    '/workspace/$workspaceSlug/knowledge/sources': {
      id: '/workspace/$workspaceSlug/knowledge/sources'
      path: '/sources'
      fullPath: '/workspace/$workspaceSlug/knowledge/sources'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugKnowledgeSourcesRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRoute
    }
    '/workspace/$workspaceSlug/knowledge/snippets': {
      id: '/workspace/$workspaceSlug/knowledge/snippets'
      path: '/snippets'
      fullPath: '/workspace/$workspaceSlug/knowledge/snippets'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugKnowledgeSnippetsRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRoute
    }
    '/workspace/$workspaceSlug/knowledge/products': {
      id: '/workspace/$workspaceSlug/knowledge/products'
      path: '/products'
      fullPath: '/workspace/$workspaceSlug/knowledge/products'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugKnowledgeProductsRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRoute
    }
    '/workspace/$workspaceSlug/knowledge/documents': {
      id: '/workspace/$workspaceSlug/knowledge/documents'
      path: '/documents'
      fullPath: '/workspace/$workspaceSlug/knowledge/documents'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugKnowledgeDocumentsRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRoute
    }
    '/workspace/$workspaceSlug/knowledge/company-profiles': {
      id: '/workspace/$workspaceSlug/knowledge/company-profiles'
      path: '/company-profiles'
      fullPath: '/workspace/$workspaceSlug/knowledge/company-profiles'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRoute
    }
    '/workspace/$workspaceSlug/deals/$dealId': {
      id: '/workspace/$workspaceSlug/deals/$dealId'
      path: '/deals/$dealId'
      fullPath: '/workspace/$workspaceSlug/deals/$dealId'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugDealsDealIdRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/campaigns/$campaignId/': {
      id: '/workspace/$workspaceSlug/campaigns/$campaignId/'
      path: '/campaigns/$campaignId'
      fullPath: '/workspace/$workspaceSlug/campaigns/$campaignId'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/referrals': {
      id: '/workspace/$workspaceSlug/settings/workspace/referrals'
      path: '/workspace/referrals'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/referrals'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/members': {
      id: '/workspace/$workspaceSlug/settings/workspace/members'
      path: '/workspace/members'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/members'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceMembersRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/integrations': {
      id: '/workspace/$workspaceSlug/settings/workspace/integrations'
      path: '/workspace/integrations'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/integrations'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/general': {
      id: '/workspace/$workspaceSlug/settings/workspace/general'
      path: '/workspace/general'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/general'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/blacklist': {
      id: '/workspace/$workspaceSlug/settings/workspace/blacklist'
      path: '/workspace/blacklist'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/blacklist'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/billing': {
      id: '/workspace/$workspaceSlug/settings/workspace/billing'
      path: '/workspace/billing'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/billing'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/settings/account/profile': {
      id: '/workspace/$workspaceSlug/settings/account/profile'
      path: '/account/profile'
      fullPath: '/workspace/$workspaceSlug/settings/account/profile'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsAccountProfileRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/settings/account/notification': {
      id: '/workspace/$workspaceSlug/settings/account/notification'
      path: '/account/notification'
      fullPath: '/workspace/$workspaceSlug/settings/account/notification'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsAccountNotificationRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRoute
    }
    '/workspace/$workspaceSlug/campaigns/setup/company-profile': {
      id: '/workspace/$workspaceSlug/campaigns/setup/company-profile'
      path: '/campaigns/setup/company-profile'
      fullPath: '/workspace/$workspaceSlug/campaigns/setup/company-profile'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success': {
      id: '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success'
      path: '/campaigns/$campaignId/launch-success'
      fullPath: '/workspace/$workspaceSlug/campaigns/$campaignId/launch-success'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugRouteRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/billing/': {
      id: '/workspace/$workspaceSlug/settings/workspace/billing/'
      path: '/'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/billing/'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/billing/success': {
      id: '/workspace/$workspaceSlug/settings/workspace/billing/success'
      path: '/success'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/billing/success'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/billing/invoices': {
      id: '/workspace/$workspaceSlug/settings/workspace/billing/invoices'
      path: '/invoices'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/billing/invoices'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/billing/cancel': {
      id: '/workspace/$workspaceSlug/settings/workspace/billing/cancel'
      path: '/cancel'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/billing/cancel'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute
    }
    '/workspace/$workspaceSlug/settings/workspace/billing/billing-info': {
      id: '/workspace/$workspaceSlug/settings/workspace/billing/billing-info'
      path: '/billing-info'
      fullPath: '/workspace/$workspaceSlug/settings/workspace/billing/billing-info'
      preLoaderRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRouteImport
      parentRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute
    }
  }
}
declare module '@tanstack/react-start/server' {
  interface ServerFileRoutesByPath {
    '/api/health': {
      id: '/api/health'
      path: '/api/health'
      fullPath: '/api/health'
      preLoaderRoute: typeof ApiHealthServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/demo-names': {
      id: '/api/demo-names'
      path: '/api/demo-names'
      fullPath: '/api/demo-names'
      preLoaderRoute: typeof ApiDemoNamesServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAdminsRoute: typeof AdminAdminsRoute
  AdminCampaignRoute: typeof AdminCampaignRoute
  AdminInboxRoute: typeof AdminInboxRoute
  AdminInvitationCodesRoute: typeof AdminInvitationCodesRoute
  AdminMonitorRoute: typeof AdminMonitorRoute
  AdminOutboxRoute: typeof AdminOutboxRoute
  AdminRealtimeJobsRoute: typeof AdminRealtimeJobsRoute
  AdminServiceRequestsRoute: typeof AdminServiceRequestsRoute
  AdminWaitlistRoute: typeof AdminWaitlistRoute
  AdminWorkspacesRoute: typeof AdminWorkspacesRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAdminsRoute: AdminAdminsRoute,
  AdminCampaignRoute: AdminCampaignRoute,
  AdminInboxRoute: AdminInboxRoute,
  AdminInvitationCodesRoute: AdminInvitationCodesRoute,
  AdminMonitorRoute: AdminMonitorRoute,
  AdminOutboxRoute: AdminOutboxRoute,
  AdminRealtimeJobsRoute: AdminRealtimeJobsRoute,
  AdminServiceRequestsRoute: AdminServiceRequestsRoute,
  AdminWaitlistRoute: AdminWaitlistRoute,
  AdminWorkspacesRoute: AdminWorkspacesRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface OnboardingRouteRouteChildren {
  OnboardingActivationRoute: typeof OnboardingActivationRoute
  OnboardingProfileRoute: typeof OnboardingProfileRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  OnboardingWaitlistPendingRoute: typeof OnboardingWaitlistPendingRoute
  OnboardingWaitlistIndexRoute: typeof OnboardingWaitlistIndexRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingActivationRoute: OnboardingActivationRoute,
  OnboardingProfileRoute: OnboardingProfileRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  OnboardingWaitlistPendingRoute: OnboardingWaitlistPendingRoute,
  OnboardingWaitlistIndexRoute: OnboardingWaitlistIndexRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

interface WorkspaceWorkspaceSlugKnowledgeRouteRouteChildren {
  WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRoute: typeof WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRoute
  WorkspaceWorkspaceSlugKnowledgeDocumentsRoute: typeof WorkspaceWorkspaceSlugKnowledgeDocumentsRoute
  WorkspaceWorkspaceSlugKnowledgeProductsRoute: typeof WorkspaceWorkspaceSlugKnowledgeProductsRoute
  WorkspaceWorkspaceSlugKnowledgeSnippetsRoute: typeof WorkspaceWorkspaceSlugKnowledgeSnippetsRoute
  WorkspaceWorkspaceSlugKnowledgeSourcesRoute: typeof WorkspaceWorkspaceSlugKnowledgeSourcesRoute
  WorkspaceWorkspaceSlugKnowledgeWebsitesRoute: typeof WorkspaceWorkspaceSlugKnowledgeWebsitesRoute
  WorkspaceWorkspaceSlugKnowledgeIndexRoute: typeof WorkspaceWorkspaceSlugKnowledgeIndexRoute
}

const WorkspaceWorkspaceSlugKnowledgeRouteRouteChildren: WorkspaceWorkspaceSlugKnowledgeRouteRouteChildren =
  {
    WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRoute:
      WorkspaceWorkspaceSlugKnowledgeCompanyProfilesRoute,
    WorkspaceWorkspaceSlugKnowledgeDocumentsRoute:
      WorkspaceWorkspaceSlugKnowledgeDocumentsRoute,
    WorkspaceWorkspaceSlugKnowledgeProductsRoute:
      WorkspaceWorkspaceSlugKnowledgeProductsRoute,
    WorkspaceWorkspaceSlugKnowledgeSnippetsRoute:
      WorkspaceWorkspaceSlugKnowledgeSnippetsRoute,
    WorkspaceWorkspaceSlugKnowledgeSourcesRoute:
      WorkspaceWorkspaceSlugKnowledgeSourcesRoute,
    WorkspaceWorkspaceSlugKnowledgeWebsitesRoute:
      WorkspaceWorkspaceSlugKnowledgeWebsitesRoute,
    WorkspaceWorkspaceSlugKnowledgeIndexRoute:
      WorkspaceWorkspaceSlugKnowledgeIndexRoute,
  }

const WorkspaceWorkspaceSlugKnowledgeRouteRouteWithChildren =
  WorkspaceWorkspaceSlugKnowledgeRouteRoute._addFileChildren(
    WorkspaceWorkspaceSlugKnowledgeRouteRouteChildren,
  )

interface WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteChildren {
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRoute
}

const WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteChildren: WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteChildren =
  {
    WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceBillingBillingInfoRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceBillingCancelRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceBillingInvoicesRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceBillingSuccessRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceBillingIndexRoute,
  }

const WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteWithChildren =
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute._addFileChildren(
    WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteChildren,
  )

interface WorkspaceWorkspaceSlugSettingsRouteRouteChildren {
  WorkspaceWorkspaceSlugSettingsIndexRoute: typeof WorkspaceWorkspaceSlugSettingsIndexRoute
  WorkspaceWorkspaceSlugSettingsAccountNotificationRoute: typeof WorkspaceWorkspaceSlugSettingsAccountNotificationRoute
  WorkspaceWorkspaceSlugSettingsAccountProfileRoute: typeof WorkspaceWorkspaceSlugSettingsAccountProfileRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteWithChildren
  WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceMembersRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceMembersRoute
  WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRoute: typeof WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRoute
}

const WorkspaceWorkspaceSlugSettingsRouteRouteChildren: WorkspaceWorkspaceSlugSettingsRouteRouteChildren =
  {
    WorkspaceWorkspaceSlugSettingsIndexRoute:
      WorkspaceWorkspaceSlugSettingsIndexRoute,
    WorkspaceWorkspaceSlugSettingsAccountNotificationRoute:
      WorkspaceWorkspaceSlugSettingsAccountNotificationRoute,
    WorkspaceWorkspaceSlugSettingsAccountProfileRoute:
      WorkspaceWorkspaceSlugSettingsAccountProfileRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceBillingRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceBillingRouteWithChildren,
    WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceBlacklistRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceGeneralRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceIntegrationsRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceMembersRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceMembersRoute,
    WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRoute:
      WorkspaceWorkspaceSlugSettingsWorkspaceReferralsRoute,
  }

const WorkspaceWorkspaceSlugSettingsRouteRouteWithChildren =
  WorkspaceWorkspaceSlugSettingsRouteRoute._addFileChildren(
    WorkspaceWorkspaceSlugSettingsRouteRouteChildren,
  )

interface WorkspaceWorkspaceSlugRouteRouteChildren {
  WorkspaceWorkspaceSlugKnowledgeRouteRoute: typeof WorkspaceWorkspaceSlugKnowledgeRouteRouteWithChildren
  WorkspaceWorkspaceSlugSettingsRouteRoute: typeof WorkspaceWorkspaceSlugSettingsRouteRouteWithChildren
  WorkspaceWorkspaceSlugCompaniesRoute: typeof WorkspaceWorkspaceSlugCompaniesRoute
  WorkspaceWorkspaceSlugContactsRoute: typeof WorkspaceWorkspaceSlugContactsRoute
  WorkspaceWorkspaceSlugHelpRoute: typeof WorkspaceWorkspaceSlugHelpRoute
  WorkspaceWorkspaceSlugInboxRoute: typeof WorkspaceWorkspaceSlugInboxRoute
  WorkspaceWorkspaceSlugNewTaskRoute: typeof WorkspaceWorkspaceSlugNewTaskRoute
  WorkspaceWorkspaceSlugServicesRoute: typeof WorkspaceWorkspaceSlugServicesRoute
  WorkspaceWorkspaceSlugIndexRoute: typeof WorkspaceWorkspaceSlugIndexRoute
  WorkspaceWorkspaceSlugDealsDealIdRoute: typeof WorkspaceWorkspaceSlugDealsDealIdRoute
  WorkspaceWorkspaceSlugTasksSessionIdRoute: typeof WorkspaceWorkspaceSlugTasksSessionIdRoute
  WorkspaceWorkspaceSlugCampaignsIndexRoute: typeof WorkspaceWorkspaceSlugCampaignsIndexRoute
  WorkspaceWorkspaceSlugDealsIndexRoute: typeof WorkspaceWorkspaceSlugDealsIndexRoute
  WorkspaceWorkspaceSlugProductsIndexRoute: typeof WorkspaceWorkspaceSlugProductsIndexRoute
  WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRoute: typeof WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRoute
  WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRoute: typeof WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRoute
  WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRoute: typeof WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRoute
}

const WorkspaceWorkspaceSlugRouteRouteChildren: WorkspaceWorkspaceSlugRouteRouteChildren =
  {
    WorkspaceWorkspaceSlugKnowledgeRouteRoute:
      WorkspaceWorkspaceSlugKnowledgeRouteRouteWithChildren,
    WorkspaceWorkspaceSlugSettingsRouteRoute:
      WorkspaceWorkspaceSlugSettingsRouteRouteWithChildren,
    WorkspaceWorkspaceSlugCompaniesRoute: WorkspaceWorkspaceSlugCompaniesRoute,
    WorkspaceWorkspaceSlugContactsRoute: WorkspaceWorkspaceSlugContactsRoute,
    WorkspaceWorkspaceSlugHelpRoute: WorkspaceWorkspaceSlugHelpRoute,
    WorkspaceWorkspaceSlugInboxRoute: WorkspaceWorkspaceSlugInboxRoute,
    WorkspaceWorkspaceSlugNewTaskRoute: WorkspaceWorkspaceSlugNewTaskRoute,
    WorkspaceWorkspaceSlugServicesRoute: WorkspaceWorkspaceSlugServicesRoute,
    WorkspaceWorkspaceSlugIndexRoute: WorkspaceWorkspaceSlugIndexRoute,
    WorkspaceWorkspaceSlugDealsDealIdRoute:
      WorkspaceWorkspaceSlugDealsDealIdRoute,
    WorkspaceWorkspaceSlugTasksSessionIdRoute:
      WorkspaceWorkspaceSlugTasksSessionIdRoute,
    WorkspaceWorkspaceSlugCampaignsIndexRoute:
      WorkspaceWorkspaceSlugCampaignsIndexRoute,
    WorkspaceWorkspaceSlugDealsIndexRoute:
      WorkspaceWorkspaceSlugDealsIndexRoute,
    WorkspaceWorkspaceSlugProductsIndexRoute:
      WorkspaceWorkspaceSlugProductsIndexRoute,
    WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRoute:
      WorkspaceWorkspaceSlugCampaignsCampaignIdLaunchSuccessRoute,
    WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRoute:
      WorkspaceWorkspaceSlugCampaignsSetupCompanyProfileRoute,
    WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRoute:
      WorkspaceWorkspaceSlugCampaignsCampaignIdIndexRoute,
  }

const WorkspaceWorkspaceSlugRouteRouteWithChildren =
  WorkspaceWorkspaceSlugRouteRoute._addFileChildren(
    WorkspaceWorkspaceSlugRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  WorkspaceWorkspaceSlugRouteRoute:
    WorkspaceWorkspaceSlugRouteRouteWithChildren,
  SigninExpiredRoute: SigninExpiredRoute,
  SigninSsoCallbackRoute: SigninSsoCallbackRoute,
  WorkspaceNewTaskRoute: WorkspaceNewTaskRoute,
  SigninIndexRoute: SigninIndexRoute,
  DemoStartServerFuncsRoute: DemoStartServerFuncsRoute,
  ShareTasksShareTokenRoute: ShareTasksShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
const rootServerRouteChildren: RootServerRouteChildren = {
  ApiDemoNamesServerRoute: ApiDemoNamesServerRoute,
  ApiHealthServerRoute: ApiHealthServerRoute,
}
export const serverRouteTree = rootServerRouteImport
  ._addFileChildren(rootServerRouteChildren)
  ._addFileTypes<FileServerRouteTypes>()
